<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 17:14:27
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 17:20:19
 -->
<template>
  <div class="deviceStatus">
    <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">设备状态</span>
      </div>
      <div class="content">
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/totalDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.total}}</div>
              <div class="label">设备总数</div>
            </div>
          </div>
        </div>
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/accessDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.joined}}</div>
              <div class="label">接入平台数量</div>
            </div>
          </div>
        </div>
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/onlineDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.online}}</div>
              <div class="label">设备在线</div>
            </div>
          </div>
        </div>
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/abnormalDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.fail}}</div>
              <div class="label">设备异常</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'deviceStatus',
  components: {
  },
  data () {
    return {
      deviceStatusData: {},
    }
  },
  methods: {
    /**
     * @description                   获取设备状态数据
     * @return {undefied}             无返回值
     */
    getDeviceStatusData () {
      this.$http.get('/rest/screen/hlpz/device/summary')
        .then(res => {
          if (res.code === 0) {
            this.deviceStatusData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getDeviceStatusData()
  },
}
</script>

<style lang="less" scoped>
  .deviceStatus {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 40px;
      font-size: 20px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .content {
      width: 100%;
      height: calc(100% - 40px);
      .itemContainer {
        width: 25%;
        height: 100%;
        display: inline-block;
        .item {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-around;
          align-items: center;
          img {
            width: 120px;
          }
          .count {
            font-size: 24px;
            text-align: center;
            .value {
              color: #05dbe3;
              font-weight: bold;
              margin-bottom: 1vh;
            }
            .label {
              color: #ededed;
              font-size: 16px;
            }
          }
          &:nth-of-type(3) {
            .count {
              .value {
                color: #49df59;
              }
            }
          }
          &:nth-of-type(4) {
            .count {
              .value {
                color: #e93d34;
              }
            }
          }
        }
      }
    }
  }
</style>
